import React from 'react';
import { useAppSelector } from '@/store';

export default function withConfigOnOff<P = any>(
    selectors: ((state: any) => boolean) | Array<(state: any) => boolean>
) {
    const selectorList = Array.isArray(selectors) ? selectors : [selectors];

    return function (WrappedComponent: React.ComponentType<P>): React.FC<React.PropsWithChildren<P>> {
        const ComponentWithConfig: React.FC<React.PropsWithChildren<P>> = (props) => {
            const allTrue = selectorList.every((sel) => {
                const result = useAppSelector(sel);
                return Boolean(result);
            })

            if (!allTrue) return null;

            return <WrappedComponent {...props} />;
        };

        return ComponentWithConfig;
    };

}